import { Form } from "antd";

import { useGetAsset } from "@/entities/asset";

export const useParentAssetCoordinates = (form = {}) => {
  // Note: form field named "asset" is the parent asset
  // and the value of that form field is the parent asset id
  const parentAsset = Form.useWatch("asset", form);
  const parentAssetId = parentAsset?.value;

  const { isSuccess, asset } = useGetAsset(parentAssetId, {
    params: { ["fields[assets]"]: "coordinate" },
    enabled: !!parentAssetId,
  });

  return isSuccess ? asset?.coordinate : null;
};
